import { render, staticRenderFns } from "./StAutocomplete.vue?vue&type=template&id=4c9a8172&"
import script from "./StAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports